// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  list: {
    marginTop: theme.spacing(2),
  },
  foldButton: {
    marginTop: theme.spacing(0.5),
    padding: 0,
    minWidth: 0,
    textTransform: 'none',
  },
});

export default styles;
